type DropDownColor = {
    color: string
    className?: string
}
export const DropDown = ({color, className}:DropDownColor) => {
    return <svg xmlns="http://www.w3.org/2000/svg" className={className} width="24px" height="24px" viewBox="0 0 24 24"><rect x="0" fill="none" width="24" height="24"/><g><path d="M7 10l5 5 5-5" style={{fill:color}}/></g></svg>
}